import { render, staticRenderFns } from "./close_open_slots.vue?vue&type=template&id=9ca4e230&"
import script from "./close_open_slots.vue?vue&type=script&lang=js&"
export * from "./close_open_slots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports